import React from 'react';
import './Backup_products.css';
import { Link } from 'react-router-dom'; // Needed if you're using React Router

const products = [
     { image: '/Assets/ProductGrid_Iamges/Roller.png', name: 'ROLLER BLINDS', link: '/products/roller-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Roman.png', name: 'ROMAN BLINDS', link: '/products/roman-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Roller-With-Curtain.jpg', name: 'CURTAINS', link: '/products/blinds-with-curtain' },
    { image: '/Assets/ProductGrid_Iamges/Luzon.png', name: 'LUZON BLINDS', link: '/products/luzon-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Wooden.png', name: 'WOODEN - VENETIAN BLINDS', link: '/products/wooden-venetian-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Printed.png', name: 'PRINTED BLINDS', link: '/printed-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Skylight.png', name: 'SKYLIGHT BLINDS', link: '/products/skylight-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Colby.png', name: 'COLBY BLINDS', link: '/products/colby-blinds' },
    { image: '/Assets/ProductGrid_Iamges/17Automation.webp', name: 'AUTOMATION', link: '/automation' },
    { image: '/Assets/ProductGrid_Iamges/Sierra.png', name: 'SIERRA BLINDS', link: '/products/sierra-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Panel.png', name: 'PANEL BLINDS', link: '/products/panel-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Grayson.png', name: 'GRAYSON BLINDS', link: '/products/grayson-blinds' },
    { image: '/Assets/ProductGrid_Iamges/01-meliso-blinds-scaled.webp', name: 'MELISO BLINDS', link: '/products/meliso-blinds' },
    { image: '/Assets/ProductGrid_Iamges/16Eton.webp', name: 'ETON BLINDS', link: '/products/eton-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Patricia.png', name: 'PATRICIA BLINDS', link: '/products/patricia-blinds' },
    { image: '/Assets/ProductGrid_Iamges/13Dorren.webp', name: 'DORREN BLINDS', link: '/products/dorren-blinds' },
    { image: '/Assets/ProductGrid_Iamges/Vertical.png', name: 'VERTICAL BLINDS', link: '/products/vertical-blinds' },
     { image: '/Assets/ProductGrid_Iamges/Arcline.png', name: 'ARCLINE BLINDS', link: '/products/arcline-blinds' },
];


const ProductGrid = () => {
    return (
        <section className="Product_Page-Grid">
            <div className="product-Grid">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Products</h1>
                    <nav className="products-breadcrumb" style={{ margin: '4px 0 12px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                        <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                        <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                        <span>Products</span>
                    </nav>
                    <p className="Page_Subtitle-Dark">Discover our stunning array of window Covering Fashion where style meets luxury</p>
                </div>


                <div className="grid-container">
                    <div className="section-header">
                        <p><strong>Callistus Window Covering Products</strong> are customized. We design & assemble our blinds to accuracy with variety of fabrics, designs and operating systems. Our commitment to quality and innovation gives our customers freedom to select from wide range of features, fabrics, colours and operating systems.</p>
                    </div>
                    {products.map((product, index) => (
                        <Link to={`${product.link}`} key={index} className="product-card">
                            <div className="product-name">{product.name}</div>
                            <img src={product.image} alt={product.name} className="product-image" />
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProductGrid;